/*
 *
 * Survey constants
 *
 */

export const DEFAULT_ACTION = "app/Survey/DEFAULT_ACTION"

export const GET_SURVEY_WATCHER = "app/Survey/GET_SURVEY_WATCHER"
export const GET_SURVEY_SUCCESS = "app/Survey/GET_SURVEY_SUCCESS"
export const GET_SURVEY_FAILED = "app/Survey/GET_SURVEY_FAILED"

export const UPDATE_SURVEY_WATCHER = "app/Survey/UPDATE_SURVEY_WATCHER"
export const UPDATE_SURVEY_SUCCESS = "app/Survey/UPDATE_SURVEY_SUCCESS"
export const UPDATE_SURVEY_FAILED = "app/Survey/UPDATE_SURVEY_FAILED"

export const DELETE_SURVEY_WATCHER = "app/Survey/DELETE_SURVEY_WATCHER"
export const DELETE_SURVEY_SUCCESS = "app/Survey/DELETE_SURVEY_SUCCESS"
export const DELETE_SURVEY_FAILED = "app/Survey/DELETE_SURVEY_FAILED"

export const DELETE_ALL_QUESTIONS_WATCHER =
  "app/Survey/DELETE_ALL_QUESTIONS_WATCHER"
export const DELETE_ALL_QUESTIONS_SUCCESS =
  "app/Survey/DELETE_ALL_QUESTIONS_SUCCESS"
export const DELETE_ALL_QUESTIONS_FAILED =
  "app/Survey/DELETE_ALL_QUESTIONS_FAILED"

export const GET_SURVEY_ENPS_WATCHER = "app/Survey/GET_SURVEY_ENPS_WATCHER"
export const GET_SURVEY_ENPS_SUCCESS = "app/Survey/GET_SURVEY_ENPS_SUCCESS"
export const GET_SURVEY_ENPS_FAILED = "app/Survey/GET_SURVEY_ENPS_FAILED"

export const GET_SURVEY_QUALITATIVE_WATCHER =
  "app/Survey/GET_SURVEY_QUALITATIVE_WATCHER"
export const GET_SURVEY_QUALITATIVE_SUCCESS =
  "app/Survey/GET_SURVEY_QUALITATIVE_SUCCESS"
export const GET_SURVEY_QUALITATIVE_FAILED =
  "app/Survey/GET_SURVEY_QUALITATIVE_FAILED"

export const UPDATE_DIMENSION_WATCHER = "app/Survey/UPDATE_DIMENSION_WATCHER"
export const UPDATE_DIMENSION_SUCCESS = "app/Survey/UPDATE_DIMENSION_SUCCESS"
export const UPDATE_DIMENSION_FAILED = "app/Survey/UPDATE_DIMENSION_FAILED"

export const GET_DIMENSION_WATCHER = "app/Survey/GET_DIMENSION_WATCHER"
export const GET_DIMENSION_SUCCESS = "app/Survey/GET_DIMENSION_SUCCESS"
export const GET_DIMENSION_FAILED = "app/Survey/GET_DIMENSION_FAILED"

export const GET_DIMENSIONS_QUESTION_WATCHER =
  "app/Survey/GET_DIMENSIONS_QUESTION_WATCHER"
export const GET_DIMENSIONS_QUESTION_SUCCESS =
  "app/Survey/GET_DIMENSIONS_QUESTION_SUCCESS"
export const GET_DIMENSIONS_QUESTION_FAILED =
  "app/Survey/GET_DIMENSIONS_QUESTION_FAILED"

export const GET_QUESTION_WATCHER = "app/Survey/GET_QUESTION_WATCHER"
export const GET_QUESTION_SUCCESS = "app/Survey/GET_QUESTION_SUCCESS"
export const GET_QUESTION_FAILED = "app/Survey/GET_QUESTION_FAILED"

export const CREATE_QUESTION_WATCHER = "app/Survey/CREATE_QUESTION_WATCHER"
export const CREATE_QUESTION_SUCCESS = "app/Survey/CREATE_QUESTION_SUCCESS"
export const CREATE_QUESTION_FAILED = "app/Survey/CREATE_QUESTION_FAILED"

export const UPDATE_QUESTION_WATCHER = "app/Survey/UPDATE_QUESTION_WATCHER"
export const UPDATE_QUESTION_SUCCESS = "app/Survey/UPDATE_QUESTION_SUCCESS"
export const UPDATE_QUESTION_FAILED = "app/Survey/UPDATE_QUESTION_FAILED"

export const DELETE_QUESTION_WATCHER = "app/Survey/DELETE_QUESTION_WATCHER"
export const DELETE_QUESTION_SUCCESS = "app/Survey/DELETE_QUESTION_SUCCESS"
export const DELETE_QUESTION_FAILED = "app/Survey/DELETE_QUESTION_FAILED"

export const UPDATE_QUESTIONDIMENSION_WATCHER =
  "app/Survey/UPDATE_QUESTIONDIMENSION_WATCHER"
export const UPDATE_QUESTIONDIMENSION_SUCCESS =
  "app/Survey/UPDATE_QUESTIONDIMENSION_SUCCESS"
export const UPDATE_QUESTIONDIMENSION_FAILED =
  "app/Survey/UPDATE_QUESTIONDIMENSION_FAILED"

export const GET_QUESTION_TYPES_WATCHER =
  "app/Survey/GET_QUESTION_TYPES_WATCHER"
export const GET_QUESTION_TYPES_SUCCESS =
  "app/Survey/GET_QUESTION_TYPES_SUCCESS"
export const GET_QUESTION_TYPES_FAILED = "app/Survey/GET_QUESTION_TYPES_FAILED"

export const UPDATE_QUALITATIVE_WATCHER =
  "app/Survey/UPDATE_QUALITATIVE_WATCHER"
export const UPDATE_QUALITATIVE_SUCCESS =
  "app/Survey/UPDATE_QUALITATIVE_SUCCESS"
export const UPDATE_QUALITATIVE_FAILED = "app/Survey/UPDATE_QUALITATIVE_FAILED"

export const GET_CONFIG_SURVEY_WATCHER = "app/Survey/GET_CONFIG_SURVEY_WATCHER"
export const GET_CONFIG_SURVEY_SUCCESS = "app/Survey/GET_CONFIG_SURVEY_SUCCESS"
export const GET_CONFIG_SURVEY_FAILED = "app/Survey/GET_CONFIG_SURVEY_FAILED"

export const UPDATE_CONFIG_SURVEY_WATCHER =
  "app/Survey/UPDATE_CONFIG_SURVEY_WATCHER"
export const UPDATE_CONFIG_SURVEY_SUCCESS =
  "app/Survey/UPDATE_CONFIG_SURVEY_SUCCESS"
export const UPDATE_CONFIG_SURVEY_FAILED =
  "app/Survey/UPDATE_CONFIG_SURVEY_FAILED"

export const DOWNLOAD_SURVEY_WATCHER = "app/Survey/DOWNLOAD_SURVEY_WATCHER"
export const DOWNLOAD_SURVEY_SUCCESS = "app/Survey/DOWNLOAD_SURVEY_SUCCESS"
export const DOWNLOAD_SURVEY_FAILED = "app/Survey/DOWNLOAD_SURVEY_FAILED"

export const GET_QUESTIONS_WATCHER = "app/Survey/GET_QUESTIONS_WATCHER"
export const GET_QUESTIONS_SUCCESS = "app/Survey/GET_QUESTIONS_SUCCESS"
export const GET_QUESTIONS_FAILED = "app/Survey/GET_QUESTIONS_FAILED"

export const SEND_EMAIL_PREVIEW_SURVERY_WATCHER =
  "app/Survey/SEND_EMAIL_PREVIEW_SURVERY_WATCHER"
export const SEND_EMAIL_PREVIEW_SURVERY_SUCCESS =
  "app/Survey/SEND_EMAIL_PREVIEW_SURVERY_SUCCESS"
export const SEND_EMAIL_PREVIEW_SURVERY_FAILED =
  "app/Survey/SEND_EMAIL_PREVIEW_SURVERY_FAILED"

export const UPLOAD_BG_IMAGE_WATCHER = "app/Survey/UPLOAD_BG_IMAGE_WATCHER"
export const UPLOAD_BG_IMAGE_SUCCESS = "app/Survey/UPLOAD_BG_IMAGE_SUCCESS"
export const UPLOAD_BG_IMAGE_FAILED = "app/Survey/UPLOAD_BG_IMAGE_FAILED"

export const UPLOAD_LOGO_WATCHER = "app/Survey/UPLOAD_LOGO_WATCHER"
export const UPLOAD_LOGO_SUCCESS = "app/Survey/UPLOAD_LOGO_SUCCESS"
export const UPLOAD_LOGO_FAILED = "app/Survey/UPLOAD_LOGO_FAILED"

export const GET_QUESTION_MULTIPLE_CHOICE_WATCHER =
  "app/Survey/GET_QUESTION_MULTIPLE_CHOICE_WATCHER"
export const GET_QUESTION_MULTIPLE_CHOICE_SUCCESS =
  "app/Survey/GET_QUESTION_MULTIPLE_CHOICE_SUCCESS"
export const GET_QUESTION_MULTIPLE_CHOICE_FAILED =
  "app/Survey/GET_QUESTION_MULTIPLE_CHOICE_FAILED"

export const GET_SEGMENTS_WATCHER = "app/Survey/GET_SEGMENTS_WATCHER"
export const GET_SEGMENTS_SUCCESS = "app/Survey/GET_SEGMENTS_SUCCESS"
export const GET_SEGMENTS_FAILED = "app/Survey/GET_SEGMENTS_FAILED"

export const GET_SURVEY_TYPES_WATCHER = "app/Survey/GET_SURVEY_TYPES_WATCHER"
export const GET_SURVEY_TYPES_SUCCESS = "app/Survey/GET_SURVEY_TYPES_SUCCESS"
export const GET_SURVEY_TYPES_FAILED = "app/Survey/GET_SURVEY_TYPES_FAILED"

export const GET_SCOPE_TYPES_WATCHER = "app/Survey/GET_SCOPE_TYPES_WATCHER"
export const GET_SCOPE_TYPES_SUCCESS = "app/Survey/GET_SCOPE_TYPES_SUCCESS"
export const GET_SCOPE_TYPES_FAILED = "app/Survey/GET_SCOPE_TYPES_FAILED"
